export default "__VITE_ASSET__DoogkN6Y__"